import React from 'react';

import * as ST from './styled';

const Wrapper = ({ ...props }): JSX.Element => {
    return <ST.Wrapper {...props}/>;
};

export default Wrapper;
